import React, { useState } from "react";
// MUI
import { Grid2 } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
// Styling
import styles from "./CloneSite.module.scss";
import { ReactComponent as Clonesite } from "../../../../../../GlobalAssets/svg/clonesite12.svg";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";

export default function CloneSite(props) {
  const {
    cloneSite,
    setCloneSite,
    cloneSiteData,
    onCloneSiteSelect,
    sitesInfo,
  } = props;

  const [popup, setPopup] = useState({
    popupstate: false,
    popuptype: "",
    popuptitle: "",
    popupsubtitle: "",
    popupbutton: false,
    popupcancel: false,
    popupbuttontitle: "",
    popupcanceltitle: "",
    popupbuttonFunction: () => {},
    popupcancelFunction: () => {},
  });

  let arnInfo = sitesInfo?.siteArns || {};

  const handleSelectType = (index, siteId, title, installType) => {
    if (cloneSite === index) {
      setCloneSite(null);
      onCloneSiteSelect(null);
    } else {
      setCloneSite(index);
      onCloneSiteSelect(siteId, title, installType);
    }
  };

  const ActivatePopup = (type) => {
    if (type === "site-down") {
      setPopup({
        popupstate: true,
        popuptype: "info",
        popuptitle: "Unable to Proceed",
        popupsubtitle: "The site appears to be down at the moment.",
        popupcancel: true,
        popupbutton: true,
        popupbuttontitle: "Ok",
        popupbuttonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "none") {
      setPopup({ popupstate: false });
    }
  };

  // useMakeApiCalls(() => {
  //   if (cloneSiteDetails === "") {
  //     getStore().dispatch({
  //       type: Actions.API_SITES_LB_ARN,
  //       data: {
  //         siteName: siteTypes.siteCloneName,
  //         siteId: siteId,
  //       },
  //     });
  //   }
  // });

  const createCloneSite = (index, siteId, title, installType) => {
    const siteData = arnInfo[siteId];
    if (siteData === false) {
      ActivatePopup("site-down");
    } else {
      handleSelectType(index, siteId, title, installType);
    }
  };

  const CloneImage = ({ icon }) => {
    return icon ? (
      <img src={icon} alt="cloneSite" className={styles.Image} />
    ) : (
      <Clonesite className={styles.NoImage} />
    );
  };

  return (
    <>
      <Grid2 className={styles.CloneSite}>
        <Grid2 className={styles.header}>Clone an existing environment</Grid2>
        <Grid2 className={styles.CloneSiteFlexBox}>
          {cloneSiteData.map(({ icon, title, siteId, installType }, index) => (
            <Grid2
              key={index}
              className={`${styles.Container} ${
                cloneSite === index ? styles.active : ""
              }`}
              onClick={() => createCloneSite(index, siteId, title, installType)}
            >
              <CloneImage icon={icon} />
              <Grid2 className={styles.titleBackground}>
                <Grid2 className={styles.title}>{title}</Grid2>
              </Grid2>
              {cloneSite === index && (
                <Grid2 className={styles.tickBox}>
                  <CheckOutlinedIcon className={styles.Check} />
                </Grid2>
              )}
            </Grid2>
          ))}
        </Grid2>
      </Grid2>
      <section>
        <FormPopup
          trigger={popup.popupstate}
          setTrigger={setPopup}
          type={popup.popuptype}
          title={popup.popuptitle}
          subtitle={popup.popupsubtitle}
          button={popup.popupbutton}
          cancel={popup.popupcancel}
          cancelTitle={popup.popupcanceltitle}
          buttonTitle={popup.popupbuttontitle}
          buttonFunction={popup.popupbuttonFunction}
          cancelFunction={popup.popupcancelFunction}
        />
      </section>
    </>
  );
}
